import { PkDivider } from '@uefadigital/panenka-react';
import { memo } from 'react';

import { useTranslateFn } from '@shared/Translate';

const TeamsDisclaimer = ({ tag = 'teams_disclaimer' }: { tag?: string }) => {
  const t = useTranslateFn();

  return (
    <>
      <PkDivider direction='horizontal' className='pk-mb--m' />
      <div className='pk-font-size--xs pk-font-size-sm--s pk-text--text-02 pk-line-height--lg'>{t(tag)}</div>
    </>
  );
};

export default memo(TeamsDisclaimer);
